import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("../views/login/index"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("../views/404"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("../views/home/index"),
        meta: {
          title: "首页",
          icon: "home"
        }
      }
    ]
  }
];
export const asyncRouterMap = [
  {
    path: "/pms",
    component: Layout,
    redirect: "/pms/product",
    name: "pms",
    meta: {
      title: "商品管理",
      icon: "product"
    },
    children: [
      {
        path: "product",
        name: "product",
        component: () => import("@/views/pms/product/index"),
        meta: {
          perms: ["pms:product:list"],
          title: "商品列表",
          icon: "product-list"
        }
      },
      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/pms/product/add"),
        meta: {
          perms: ["pms:product:create"],
          title: "添加商品",
          icon: "product-add"
        }
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/pms/product/update"),
        meta: {
          perms: ["pms:product:update"],
          title: "修改商品",
          icon: "product-add"
        },
        hidden: true
      },
      {
        path: "productDetail",
        name: "productDetail",
        component: () => import("@/views/pms/product/productDetail"),
        meta: {
          perms: ["pms:product:read"],
          title: "商品详情"
        },
        hidden: true
      },
      {
        path: "productPre",
        name: "productPre",
        component: () => import("@/views/pms/booking/index"),
        meta: {
          perms: ["pms:productPre:list"],
          title: "预售商品列表",
          icon: "product-list"
        }
      },
      {
        path: "addPreProduct",
        name: "addPreProduct",
        component: () => import("@/views/pms/booking/add"),
        meta: {
          perms: ["pms:addPreProduct:create"],
          title: "预售添加商品",
          icon: "product-add"
        }
      },
      {
        path: "updatePreProduct",
        name: "updatePreProduct",
        component: () => import("@/views/pms/booking/update"),
        meta: {
          perms: ["pms:updatePreProduct:update"],
          title: "预售修改商品",
          icon: "product-add"
        },
        hidden: true
      },
      {
        path: "productPreDetail",
        name: "productPreDetail",
        component: () => import("@/views/pms/booking/productDetail"),
        meta: {
          perms: ["pms:productPreDetail:read"],
          title: "预售商品详情"
        },
        hidden: true
      },
      {
        path: "customList",
        name: "customList",
        component: () => import("@/views/pms/custom/customList"),
        meta: {
          perms: ["mms:customList:read"],
          title: "私人定制范围列表",
          icon: "mms-list"
        }
      },
      {
        path: "customAdd",
        name: "customAdd",
        component: () => import("@/views/pms/custom/add"),
        meta: {
          perms: ["mms:customAdd:read"],
          title: "添加私人定制范围"
        },
        hidden: true
      },
      {
        path: "customEdit",
        name: "customEdit",
        component: () => import("@/views/pms/custom/edit"),
        meta: {
          perms: ["mms:customEdit:read"],
          title: "编辑私人定制范围"
        },
        hidden: true
      },
      {
        path: "customFormList",
        name: "customFormList",
        component: () => import("@/views/pms/custom/customFormList"),
        meta: {
          perms: ["mms:customFormList:read"],
          title: "私人定制表单列表",
          icon: "mms-list"
        }
      },
      {
        path: "productCate",
        name: "productCate",
        component: () => import("@/views/pms/productCate/index"),
        meta: {
          perms: ["pms:productCategory:list"],
          title: "商品分类",
          icon: "product-cate"
        }
      },
      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/pms/productCate/add"),
        meta: {
          perms: ["pms:productCategory:create"],
          title: "添加商品分类"
        },
        hidden: true
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/pms/productCate/update"),
        meta: {
          perms: ["pms:productCategory:update"],
          title: "修改商品分类"
        },
        hidden: true
      },
      {
        path: "productAttr",
        name: "productAttr",
        component: () => import("@/views/pms/productAttr/index"),
        meta: {
          perms: ["pms:productAttribute:list"],
          title: "商品属性",
          icon: "product-attr"
        }
      },
      {
        path: "productAttrList",
        name: "productAttrList",
        component: () => import("@/views/pms/productAttr/productAttrList"),
        meta: {
          perms: ["pms:productAttribute:list"],
          title: "商品属性列表"
        },
        hidden: true
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/pms/productAttr/addProductAttr"),
        meta: {
          perms: ["pms:productAttribute:create"],
          title: "添加商品属性"
        },
        hidden: true
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () => import("@/views/pms/productAttr/updateProductAttr"),
        meta: {
          perms: ["pms:productAttribute:update"],
          title: "修改商品属性"
        },
        hidden: true
      },
      {
        path: "productComment",
        name: "productComment",
        component: () => import("@/views/pms/productComment/index"),
        meta: {
          perms: ["pms:comment:list"],
          title: "评价管理",
          icon: "product-comment"
        }
      },
      {
        path: "pCommentDetail",
        name: "pCommentDetail",
        component: () => import("@/views/pms/productComment/pCommentDetail"),
        meta: {
          perms: ["pms:comment:read"],
          title: "评价详情"
        },
        hidden: true
      },
      {
        path: "pCommentReply",
        name: "pCommentReply",
        component: () => import("@/views/pms/productComment/pCommentReply"),
        meta: {
          perms: ["pms:commentReplay:list"],
          title: "回复评价"
        },
        hidden: true
      },
      {
        path: "brand",
        name: "brand",
        component: () => import("@/views/pms/brand/index"),
        meta: {
          perms: ["pms:brand:list"],
          title: "品牌管理",
          icon: "product-brand"
        },
        hidden: true
      },
      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/pms/brand/add"),
        meta: {
          perms: ["pms:brand:create"],
          title: "添加品牌"
        },
        hidden: true
      },
      {
        path: "updateBrand",
        name: "updateBrand",
        component: () => import("@/views/pms/brand/update"),
        meta: {
          perms: ["pms:brand:update"],
          title: "编辑品牌"
        },
        hidden: true
      },
      {
        path: "freight",
        name: "freight",
        component: () => import("@/views/pms/freight/index"),
        meta: {
          perms: ["pms:feightTemplate:list"],
          title: "运费模板",
          icon: "freight"
        }
      },
      {
        path: "addFreight",
        name: "addFreight",
        component: () => import("@/views/pms/freight/addFreight"),
        meta: {
          perms: ["pms:feightTemplate:create"],
          title: "新增运费模块"
        },
        hidden: true
      },
      {
        path: "editFreight",
        name: "editFreight",
        component: () => import("@/views/pms/freight/editFreight"),
        meta: {
          perms: ["pms:feightTemplate:update"],
          title: "修改运费模块"
        },
        hidden: true
      },
      {
        path: "sendNoList",
        name: "sendNoList",
        component: () => import("@/views/pms/noDelivery/index"),
        meta: {
          perms: ["pms:feightTemplate:list"],
          title: "不发货区域列表",
          icon: "freight"
        }
      },
      {
        path: "addSendNo",
        name: "addSendNo",
        component: () => import("@/views/pms/noDelivery/addFreight"),
        meta: {
          perms: ["pms:feightTemplate:create"],
          title: "新增不发货区域"
        },
        hidden: true
      },
      {
        path: "editSendNo",
        name: "editSendNo",
        component: () => import("@/views/pms/noDelivery/editFreight"),
        meta: {
          perms: ["pms:feightTemplate:update"],
          title: "修改不发货区域"
        },
        hidden: true
      },
      {
        path: "picLibrary",
        name: "picLibrary",
        component: () => import("@/views/pms/picLibrary/index"),
        meta: {
          perms: ["pms:picLibrary:list"],
          title: "图片库",
          icon: "pm-tubiao"
        }
      },
      {
        path: "inventory",
        name: "inventory",
        component: () => import("@/views/pms/inventory/inventoryList"),
        meta: {
          perms: ["pms:inventoryList:list"],
          title: "商品库存列表",
          icon: "pm-tubiao"
        }
      },
      {
        path: "inventoryLogList",
        name: "inventoryLogList",
        component: () => import("@/views/pms/inventory/inventoryLogList"),
        meta: {
          perms: ["pms:inventoryLogList:list"],
          title: "商品库存日志列表",
          icon: "pm-tubiao"
        },
        hidden: true
      },
      {
        path: "picDetail",
        name: "picDetail",
        component: () => import("@/views/pms/picLibrary/picDetail"),
        meta: {
          perms: ["pms:picLibrary:read"],
          title: "图片库"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/oms",
    component: Layout,
    redirect: "/oms/order",
    name: "oms",
    meta: {
      title: "订单管理",
      icon: "order"
    },
    children: [
      {
        path: "order",
        name: "order",
        component: () => import("@/views/oms/order/index"),
        meta: {
          keepAlive: true,
          perms: ["oms:order:list"],
          title: "订单列表",
          icon: "oms-list"
        }
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/oms/order/orderDetail"),
        meta: {
          perms: ["oms:order:read"],
          title: "订单详情"
        },
        hidden: true
      },
      {
        path: "logistics",
        name: "logistics",
        component: () => import("@/views/oms/order/logistics"),
        meta: {
          perms: ["oms:logistics:read"],
          title: "物流详情"
        },
        hidden: true
      },
      {
        path: "orderSetting",
        name: "orderSetting",
        component: () => import("@/views/oms/order/setting"),
        meta: {
          perms: ["oms:orderSetting:read"],
          title: "订单设置",
          icon: "order-setting"
        }
      },
      {
        path: "refundReasonSetting",
        name: "refundReasonSetting",
        component: () => import("@/views/oms/order/refundReason"),
        meta: {
          perms: ["oms:refundReasonSetting:read"],
          title: "退款原因设置",
          icon: "oms-tuikuan"
        }
      },
      {
        path: "deliverGoodsAdd",
        name: "deliverGoodsAdd",
        component: () => import("@/views/oms/order/deliverGoodsAdd"),
        meta: {
          perms: ["oms:deliverGoodsAdd:list"],
          title: "收货地址列表",
          icon: "oms-delivery"
        }
      },
      {
        path: "expressCompanyList",
        name: "expressCompanyList",
        component: () => import("@/views/oms/order/expressCompanyList"),
        meta: {
          perms: ["oms:expressCompanyList:list"],
          title: "快递公司列表",
          icon: "oms-company"
        }
      },
      {
        path: "returnApply",
        name: "returnApply",
        component: () => import("@/views/oms/apply/index"),
        meta: {
          perms: ["oms:returnApply:list"],
          title: "退货申请处理",
          icon: "order-return"
        }
      },
      {
        path: "returnList",
        name: "returnList",
        component: () => import("@/views/oms/apply/return"),
        meta: {
          perms: ["oms:returnOnly:list"],
          title: "退款申请处理",
          icon: "order-return"
        }
      },
      // {
      //   path: 'returnReason',
      //   name: 'returnReason',
      //   component: () => import('@/views/oms/apply/reason'),
      //   meta: {title: '退货原因设置', icon: 'order-return-reason'}
      // },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/oms/apply/applyDetail"),
        meta: {
          perms: ["oms:returnApplyDetail:read"],
          title: "退货订单详情"
        },
        hidden: true
      },
      {
        path: "changeApply",
        name: "changeApply",
        component: () => import("@/views/oms/apply/changeApply"),
        meta: {
          perms: ["oms:changeApply:list"],
          title: "换货申请处理",
          icon: "order-return-reason"
        }
      },
      {
        path: "changeApplyDetail",
        name: "changeApplyDetail",
        component: () => import("@/views/oms/apply/changeApplyDetail"),
        meta: {
          perms: ["oms:changeApplyDetail:read"],
          title: "换货申请处理详情"
        },
        hidden: true
      },
      {
        path: "parcelIndex",
        name: "parcelIndex",
        component: () => import("@/views/oms/order/parcelIndex"),
        meta: {
          perms: ["oms:order:list"],
          title: "包裹信息列表",
          icon: "oms-list"
        }
      },
      {
        path: "exportRecord",
        name: "exportRecord",
        component: () => import("@/views/oms/order/exportRecord"),
        hidden: true,
        meta: {
          perms: ["oms:order:list"],
          title: "导出记录",
          icon: "oms-list"
        }
      }
    ]
  },
  {
    path: "/mms",
    component: Layout,
    redirect: "/mms/memberList",
    name: "mms",
    meta: {
      title: "会员管理",
      icon: "mms"
    },
    children: [
      {
        path: "memberList",
        name: "memberList",
        component: () => import("@/views/mms/memberList/index"),
        meta: {
          perms: ["mms:memberList:list"],
          title: "会员列表",
          icon: "mms-list"
        }
      },
      {
        path: "integralSubsidiary",
        name: "integralSubsidiary",
        component: () => import("@/views/mms/balance/integralSubsidiary"),
        meta: {
          perms: ["mms:integralSubsidiary:read"],
          title: "积分明细"
        },
        hidden: true
      },
      {
        path: "paymentGood",
        name: "paymentGood",
        component: () => import("@/views/mms/balance/paymentGood"),
        meta: {
          perms: ["mms:paymentGood:read"],
          title: "货款明细"
        },
        hidden: true
      },
      {
        path: "commissionGood",
        name: "commissionGood",
        component: () => import("@/views/mms/balance/commissionGood"),
        meta: {
          perms: ["mms:paymentGood:read"],
          title: "佣金明细"
        },
        hidden: true
      },
      {
        path: "grade",
        name: "grade",
        component: () => import("@/views/mms/grade/index"),
        meta: {
          perms: ["mms:memberGrade:read"],
          title: "会员等级列表",
          icon: "mms-list"
        }
      },
      {
        path: "gradeDetail",
        name: "gradeDetail",
        component: () => import("@/views/mms/grade/edit"),
        meta: {
          perms: ["mms:memberGradeDetail:read"],
          title: "会员等级详情"
        },
        hidden: true
      },
      {
        path: "agreement",
        name: "agreement",
        component: () => import("@/views/mms/grade/agreement"),
        meta: {
          perms: ["mms:agreement:list"],
          title: "会员等级协议",
          icon: "mms-list"
        }
      },
      {
        path: "memberDetail",
        name: "memberDetail",
        component: () => import("@/views/mms/memberList/memberDetail"),
        meta: {
          perms: ["mms:memberDetail:read"],
          title: "会员详情"
        },
        hidden: true
      },
      {
        path: "analysisMember",
        name: "analysisMember",
        component: () => import("@/views/mms/analysisMember/index"),
        meta: {
          perms: ["mms:analysisMember:read"],
          title: "会员统计",
          icon: "mms-analysis"
        }
      },
      {
        path: "viewsHistory",
        name: "viewsHistory",
        component: () => import("@/views/mms/History/views"),
        meta: {
          perms: ["mms:viewsHistory:list"],
          title: "会员浏览记录"
        },
        hidden: true
      },
      {
        path: "collectHistory",
        name: "collectHistory",
        component: () => import("@/views/mms/history/collect"),
        meta: {
          perms: ["mms:collectHistory:list"],
          title: "会员收藏记录"
        },
        hidden: true
      },
      {
        path: "labelList",
        name: "labelList",
        component: () => import("@/views/mms/label/labelList"),
        meta: {
          perms: ["mms:labelList:read"],
          title: "会员标签列表",
          icon: "mms-list"
        }
      },
      {
        path: "addLabel",
        name: "addLabel",
        component: () => import("@/views/mms/label/add"),
        meta: {
          perms: ["mms:addLabel:read"],
          title: "添加会员标签"
        },
        hidden: true
      },
      {
        path: "editLabel",
        name: "editLabel",
        component: () => import("@/views/mms/label/edit"),
        meta: {
          perms: ["mms:editLabel:read"],
          title: "编辑会员标签"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/vos",
    component: Layout,
    redirect: "/vos/auditList",
    name: "vos",
    meta: {
      title: "心声管理",
      icon: "mms"
    },
    children: [
      {
        path: "auditList",
        name: "auditList",
        component: () => import("@/views/vos/voice/auditList"),
        meta: {
          perms: ["mms:auditList:list"],
          title: "心声审核列表",
          icon: "mms-list"
        }
      },
      {
        path: "voiceDetail",
        name: "voiceDetail",
        component: () => import("@/views/vos/voice/voiceDetail"),
        meta: {
          perms: ["mms:voiceDetail:read"],
          title: "心声详情"
        },
        hidden: true
      },
      {
        path: "voiceList",
        name: "voiceList",
        component: () => import("@/views/vos/voice/voiceList"),
        meta: {
          perms: ["mms:voiceList:read"],
          title: "心声列表",
          icon: "mms-list"
        }
      },
      {
        path: "voiceCommentList",
        name: "voiceCommentList",
        component: () => import("@/views/vos/voice/voiceCommentList"),
        meta: {
          perms: ["mms:voiceCommentList:read"],
          title: "心声评论列表"
        },
        hidden: true
      },
      {
        path: "voiceCommentReplyList",
        name: "voiceCommentReplyList",
        component: () => import("@/views/vos/voice/voiceCommentReplyList"),
        meta: {
          perms: ["mms:voiceCommentReplyList:read"],
          title: "心声评论回复列表"
        },
        hidden: true
      },
      {
        path: "topicAuditList",
        name: "topicAuditList",
        component: () => import("@/views/vos/topic/auditList"),
        meta: {
          perms: ["mms:topicAuditList:list"],
          title: "话题审核列表",
          icon: "mms-list"
        }
      },
      {
        path: "topicDetail",
        name: "topicDetail",
        component: () => import("@/views/vos/topic/topicDetail"),
        meta: {
          perms: ["mms:topicDetail:read"],
          title: "话题详情"
        },
        hidden: true
      },
      {
        path: "topicList",
        name: "topicList",
        component: () => import("@/views/vos/topic/topicList"),
        meta: {
          perms: ["mms:topicList:read"],
          title: "话题列表",
          icon: "mms-list"
        }
      },
      {
        path: "topicGenList",
        name: "topicGenList",
        component: () => import("@/views/vos/topic/topicGenList"),
        meta: {
          perms: ["mms:topicGenList:read"],
          title: "话题跟帖列表"
        },
        hidden: true
      },
      {
        path: "topicCommentList",
        name: "topicCommentList",
        component: () => import("@/views/vos/topic/topicCommentList"),
        meta: {
          perms: ["mms:topicCommentList:read"],
          title: "话题评论列表"
        },
        hidden: true
      },
      {
        path: "topicCommentReplyList",
        name: "topicCommentReplyList",
        component: () => import("@/views/vos/topic/topicCommentReplyList"),
        meta: {
          perms: ["mms:topicCommentReplyList:read"],
          title: "话题评论回复列表"
        },
        hidden: true
      },
      {
        path: "voteList",
        name: "voteList",
        component: () => import("@/views/vos/vote/voteList"),
        meta: {
          perms: ["mms:voteList:read"],
          title: "投票列表",
          icon: "mms-list"
        }
      },
      {
        path: "voteAdd",
        name: "voteAdd",
        component: () => import("@/views/vos/vote/add"),
        meta: {
          perms: ["mms:voteAdd:read"],
          title: "添加投票活动"
        },
        hidden: true
      },
      {
        path: "voteEdit",
        name: "voteEdit",
        component: () => import("@/views/vos/vote/edit"),
        meta: {
          perms: ["mms:voteEdit:read"],
          title: "编辑投票活动"
        },
        hidden: true
      },
      {
        path: "voteProList",
        name: "voteProList",
        component: () => import("@/views/vos/vote/proList"),
        meta: {
          perms: ["mms:voteProList:read"],
          title: "活动商品列表"
        },
        hidden: true
      },
      {
        path: "voteProListDetail",
        name: "voteProListDetail",
        component: () => import("@/views/vos/vote/proListDetail"),
        meta: {
          perms: ["mms:voteProListDetail:read"],
          title: "活动商品票数列表"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/sms",
    component: Layout,
    redirect: "/sms/coupon",
    name: "sms",
    meta: {
      title: "营销管理",
      icon: "sms"
    },
    children: [
      {
        path: "limit",
        name: "limit",
        component: () => import("@/views/sms/limit/index"),
        meta: {
          perms: ["mms:groupList:list"],
          title: "抢购活动列表",
          icon: "sms-group"
        }
      },
      {
        path: "addLimit",
        name: "addLimit",
        component: () => import("@/views/sms/limit/add"),
        meta: {
          perms: ["sms:addgroup:list"],
          title: "添加抢购活动"
        },
        hidden: true
      },
      {
        path: "editLimit",
        name: "editLimit",
        component: () => import("@/views/sms/limit/edit"),
        meta: {
          perms: ["sms:editgroup:list"],
          title: "编辑抢购活动"
        },
        hidden: true
      },
      {
        path: "timeList",
        name: "timeList",
        component: () => import("@/views/sms/limit/timeIndex"),
        meta: {
          perms: ["mms:groupList:list"],
          title: "秒杀时间列表",
          icon: "sms-group"
        },
        hidden: true
      },
      {
        path: "timeListSelect",
        name: "timeListSelect",
        component: () => import("@/views/sms/limit/timeIndexSelect"),
        meta: {
          perms: ["mms:groupList:list"],
          title: "秒杀时间选择",
          icon: "sms-group"
        },
        hidden: true
      },
      {
        path: "productSelectList",
        name: "productSelectList",
        component: () => import("@/views/sms/limit/productSelectList"),
        meta: {
          perms: ["mms:groupList:list"],
          title: "秒杀商品列表",
          icon: "sms-group"
        },
        hidden: true
      },
      {
        path: "addTime",
        name: "addTime",
        component: () => import("@/views/sms/limit/addTime"),
        meta: {
          perms: ["sms:addgroup:list"],
          title: "添加秒杀时间段"
        },
        hidden: true
      },
      {
        path: "editTime",
        name: "editTime",
        component: () => import("@/views/sms/limit/editTime"),
        meta: {
          perms: ["sms:editgroup:list"],
          title: "编辑秒杀时间段"
        },
        hidden: true
      },
      {
        path: "setLimit",
        name: "setLimit",
        component: () => import("@/views/sms/limit/set"),
        meta: {
          perms: ["sms:groupActiveList:list"],
          title: "抢购活动规格设置"
        },
        hidden: true
      },
      {
        path: "coupon",
        name: "coupon",
        component: () => import("@/views/sms/coupon/index"),
        meta: {
          perms: ["sms:couponList:list"],
          title: "优惠券列表",
          icon: "sms-coupon"
        }
      },
      {
        path: "counpDetail",
        name: "counpDetail",
        component: () => import("@/views/sms/coupon/counpDetail"),
        meta: {
          perms: ["sms:couponActiveList:list"],
          title: "优惠券活动列表",
          icon: "sms-coupon"
        },
        hidden: true
      },
      {
        path: "addCoupon",
        name: "addCoupon",
        component: () => import("@/views/sms/coupon/add"),
        meta: {
          perms: ["sms:addcoupon:list"],
          title: "添加优惠券"
        },
        hidden: true
      },
      {
        path: "editCoupon",
        name: "editCoupon",
        component: () => import("@/views/sms/coupon/edit"),
        meta: {
          perms: ["sms:editcoupont:list"],
          title: "编辑优惠券"
        },
        hidden: true
      },
      {
        path: "advertise",
        name: "homeAdvertise",
        component: () => import("@/views/sms/advertise/index"),
        meta: {
          perms: ["sms:advertise:list"],
          title: "广告列表",
          icon: "sms-ad"
        }
      },
      {
        path: "addAdvertise",
        name: "addHomeAdvertise",
        component: () => import("@/views/sms/advertise/add"),
        meta: {
          perms: ["sms:addAdvertise:create"],
          title: "添加广告"
        },
        hidden: true
      },
      {
        path: "updateAdvertise",
        name: "updateHomeAdvertise",
        component: () => import("@/views/sms/advertise/update"),
        meta: {
          perms: ["sms:updateAdvertise:update"],
          title: "编辑广告"
        },
        hidden: true
      },
      {
        path: "navigation",
        name: "navigation",
        component: () => import("@/views/sms/navigation/index"),
        meta: {
          perms: ["sms:navigation:list"],
          title: "导航栏列表",
          icon: "sms-nav"
        }
      },
      {
        path: "addNavigation",
        name: "addNavigation",
        component: () => import("@/views/sms/navigation/add"),
        meta: {
          perms: ["sms:addNavigation:create"],
          title: "添加导航"
        },
        hidden: true
      },
      {
        path: "editNavigation",
        name: "editNavigation",
        component: () => import("@/views/sms/navigation/edit"),
        meta: {
          perms: ["sms:editNavigation:update"],
          title: "编辑导航"
        },
        hidden: true
      },
      {
        path: "subject",
        name: "homeSubject",
        component: () => import("@/views/sms/subject/index"),
        meta: {
          perms: ["sms:homeSubject:list"],
          title: "专题列表",
          icon: "sms-subject"
        }
      },
      {
        path: "addSubject",
        name: "addSubject",
        component: () => import("@/views/sms/subject/add"),
        meta: {
          perms: ["sms:addSubject:create"],
          title: "添加专题"
        },
        hidden: true
      },
      {
        path: "editSubject",
        name: "editSubject",
        component: () => import("@/views/sms/subject/edit"),
        meta: {
          perms: ["sms:editSubject:update"],
          title: "编辑专题"
        },
        hidden: true
      },
      {
        path: "setSubject",
        name: "setSubject",
        component: () => import("@/views/sms/subject/set"),
        meta: {
          perms: ["sms:setSubject:list"],
          title: "设置商品"
        },
        hidden: true
      },

      {
        path: "group",
        name: "group",
        component: () => import("@/views/sms/group/index"),
        meta: {
          perms: ["mms:groupList:list"],
          title: "拼团活动列表",
          icon: "sms-group"
        }
      },
      {
        path: "addGroup",
        name: "addGroup",
        component: () => import("@/views/sms/group/add"),
        meta: {
          perms: ["sms:addgroup:list"],
          title: "添加团购活动"
        },
        hidden: true
      },
      {
        path: "editGroup",
        name: "editGroup",
        component: () => import("@/views/sms/group/edit"),
        meta: {
          perms: ["sms:editgroup:list"],
          title: "编辑团购活动"
        },
        hidden: true
      },
      {
        path: "setGroup",
        name: "setGroup",
        component: () => import("@/views/sms/group/set"),
        meta: {
          perms: ["sms:groupActiveList:list"],
          title: "拼团活动列表"
        },
        hidden: true
      },
      {
        path: "groupRecord",
        name: "groupRecord",
        component: () => import("@/views/sms/group/record"),
        meta: {
          perms: ["sms:groupRecord:list"],
          title: "拼团记录"
        },
        hidden: true
      },
      {
        path: "groupRecordDetail",
        name: "groupRecordDetail",
        component: () => import("@/views/sms/group/recordDetail"),
        meta: {
          perms: ["sms:recordDetail:list"],
          title: "拼团记录详情"
        },
        hidden: true
      },
      {
        path: "creditMall",
        name: "creditMall",
        component: () => import("@/views/sms/creditMall/index"),
        meta: {
          perms: ["sms:creditMallList:list"],
          title: "积分商城",
          icon: "sms-mall"
        }
      },
      {
        path: "mallSetting",
        name: "mallSetting",
        component: () => import("@/views/sms/creditMall/set"),
        meta: {
          perms: ["sms:creditMallSet:list"],
          title: "积分商城设置"
        },
        hidden: true
      },
      {
        path: "creditSet",
        name: "creditSet",
        component: () => import("@/views/sms/creditMall/setting"),
        meta: {
          perms: ["sms:creditMallSet:list"],
          title: "积分规则设置",
          icon: "sms-mall"
        }
      },
      {
        path: "topup",
        name: "topup",
        component: () => import("@/views/sms/topup/index"),
        meta: {
          perms: ["mms:groupList:list"],
          title: "充值活动列表",
          icon: "sms-group"
        }
      },
      {
        path: "addTopup",
        name: "addTopup",
        component: () => import("@/views/sms/topup/add"),
        meta: {
          perms: ["sms:addgroup:list"],
          title: "添加充值活动"
        },
        hidden: true
      },
      {
        path: "editTopup",
        name: "editTopup",
        component: () => import("@/views/sms/topup/edit"),
        meta: {
          perms: ["sms:editgroup:list"],
          title: "编辑充值活动"
        },
        hidden: true
      },
      {
        path: "topupSetting",
        name: "topupSetting",
        component: () => import("@/views/sms/topup/setting"),
        meta: {
          perms: ["sms:editgroup:list"],
          title: "充值活动规则",
          icon: "sms-group"
        }
      },
      {
        path: "topupRecord",
        name: "topupRecord",
        component: () => import("@/views/sms/topup/record"),
        meta: {
          perms: ["sms:groupRecord:list"],
          title: "充值订单列表",
          icon: "sms-group"
        }
      },
      {
        path: "zeroActives",
        name: "zeroActives",
        component: () => import("@/views/sms/zeroActives/index"),
        meta: {
          perms: ["sms:zeroActivesList:list"],
          title: "0元活动",
          icon: "sms-mall"
        }
      },
      {
        path: "zeroActivesSetting",
        name: "zeroActivesSetting",
        component: () => import("@/views/sms/zeroActives/set"),
        meta: {
          perms: ["sms:zeroActivesSetting:list"],
          title: "0元活动设置"
        },
        hidden: true
      },
      {
        path: "confessRaise",
        name: "confessRaise",
        component: () => import("@/views/sms/confessRaise/index"),
        meta: {
          perms: ["sms:confessRaiseList:list"],
          title: "小浪认筹商品列表",
          icon: "sms-mall"
        }
      },
      {
        path: "confessRaiseSetting",
        name: "confessRaiseSetting",
        component: () => import("@/views/sms/confessRaise/set"),
        meta: {
          perms: ["sms:confessRaiseSetting:list"],
          title: "小浪认筹商品设置"
        },
        hidden: true
      },
      {
        path: "confessOrderList",
        name: "confessOrderList",
        component: () => import("@/views/sms/confessRaise/orderList"),
        meta: {
          perms: ["sms:confessOrderList:list"],
          title: "小浪进货订单记录列表",
          icon: "sms-mall"
        },
        hidden: true
      },
      {
        path: "confessOrderDetail",
        name: "confessOrderDetail",
        component: () => import("@/views/sms/confessRaise/orderDetail"),
        meta: {
          perms: ["sms:confessOrderDetail:list"],
          title: "小浪进货订单记录详情"
        },
        hidden: true
      },
      {
        path: "xiaoLangList",
        name: "xiaoLangList",
        component: () => import("@/views/sms/confessRaise/userList"),
        meta: {
          perms: ["sms:xiaoLangList:list"],
          title: "小浪用户列表",
          icon: "sms-mall"
        }
      },
      {
        path: "xiaoLangProDetail",
        name: "xiaoLangProDetail",
        component: () => import("@/views/sms/confessRaise/productList"),
        meta: {
          perms: ["sms:xiaoLangProDetail:list"],
          title: "小浪商品库存列表"
        },
        hidden: true
      },
      {
        path: "statisticalDetail",
        name: "statisticalDetail",
        component: () => import("@/views/sms/confessRaise/statisticalDetail"),
        meta: {
          perms: ["sms:statisticalDetail:list"],
          title: "小浪认购团队统计信息"
        },
        hidden: true
      },
      {
        path: "xiaoLangTeamList",
        name: "xiaoLangTeamList",
        component: () => import("@/views/sms/confessRaise/orderTeamList"),
        meta: {
          perms: ["sms:xiaoLangTeamList:list"],
          title: "小浪团队订单列表"
        },
        hidden: true
      },
      {
        path: "xiaoLangorderTeamDetail",
        name: "xiaoLangorderTeamDetail",
        component: () => import("@/views/sms/confessRaise/orderTeamDetail"),
        meta: {
          perms: ["sms:xiaoLangorderTeamDetail:list"],
          title: "小浪团队订单详情"
        },
        hidden: true
      },
      {
        path: "popWindow",
        name: "popWindow",
        component: () => import("@/views/sms/popWindow/index"),
        meta: {
          perms: ["sms:popWindow:list"],
          title: "弹窗广告列表",
          icon: "sms-mall"
        }
      },
      {
        path: "addPopWindow",
        name: "addPopWindow",
        component: () => import("@/views/sms/popWindow/add"),
        meta: {
          perms: ["sms:addPopWindow:add"],
          title: "添加弹窗广告"
        },
        hidden: true
      },
      {
        path: "editPopWindow",
        name: "editPopWindow",
        component: () => import("@/views/sms/popWindow/edit"),
        meta: {
          perms: ["sms:editPopWindow:edit"],
          title: "编辑弹窗广告"
        },
        hidden: true
      }
    ]
  },

  {
    path: "/dms",
    component: Layout,
    redirect: "/dms/distribution",
    name: "dms",
    meta: {
      title: "分销管理",
      icon: "dms"
    },
    children: [
      {
        path: "distribution",
        name: "distribution",
        component: () => import("@/views/dms/distribution/index"),
        meta: {
          perms: ["dms:distributionList:list"],
          title: "分销员列表",
          icon: "dms-list"
        }
      },
      {
        path: "setting",
        name: "setting",
        component: () => import("@/views/dms/distribution/setting"),
        meta: {
          perms: ["dms:distributionSet:list"],
          title: "分销设置",
          icon: "dms-setting"
        }
      },
      {
        path: "nextLevel",
        name: "nextLevel",
        component: () => import("@/views/dms/distribution/nextLevel"),
        meta: {
          perms: ["dms:nextLevel:list"],
          title: "直接下级数"
        },
        hidden: true
      },
      {
        path: "getMoney",
        name: "getMoney",
        component: () => import("@/views/dms/distribution/getMoney"),
        meta: {
          perms: ["dms:getMoney:list"],
          title: "佣金列表",
          icon: "dms-money"
        },
        hidden: true
      },
      {
        path: "moneyDetail",
        name: "moneyDetail",
        component: () => import("@/views/dms/distribution/moneyDetail"),
        meta: {
          perms: ["dms:moneyDetail:list"],
          title: "佣金明细"
        },
        hidden: true
      },
      {
        path: "withdrawList",
        name: "withdrawList",
        component: () => import("@/views/dms/distribution/withdrawList"),
        meta: {
          perms: ["dms:withdrawList:list"],
          title: "提现列表",
          icon: "dms-withdraw"
        }
      },
      {
        path: "withdrawDetail",
        name: "withdrawDetail",
        component: () => import("@/views/dms/distribution/withdrawDetail"),
        meta: {
          perms: ["dms:withdrawList:list"],
          title: "提现详情",
          icon: "dms-withdraw"
        },
        hidden: true
      },
      {
        path: "checkList",
        name: "checkList",
        component: () => import("@/views/dms/langYe/checkList"),
        meta: {
          perms: ["dms:checkList:list"],
          title: "审核列表",
          icon: "dms-withdraw"
        }
      },
      {
        path: "langyeList",
        name: "langyeList",
        component: () => import("@/views/dms/langYe/index"),
        meta: {
          perms: ["dms:langyeList:list"],
          title: "区代列表",
          icon: "dms-withdraw"
        }
      },
      {
        path: "LnextLevel",
        name: "LnextLevel",
        component: () => import("@/views/dms/langYe/nextLevel"),
        meta: {
          perms: ["dms:LnextLevel:list"],
          title: "区代下级列表",
          icon: "dms-withdraw"
        },
        hidden: true
      },
      {
        path: "langGetMoney",
        name: "langGetMoney",
        component: () => import("@/views/dms/langYe/getMoney"),
        meta: {
          perms: ["dms:langGetMoney:list"],
          title: "区代佣金列表",
          icon: "dms-money"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/sta",
    component: Layout,
    redirect: "/sta/proStatistical",
    name: "sta",
    meta: {
      title: "统计管理",
      icon: "sms"
    },
    alwaysShow: true,
    children: [
      {
        path: "proStatistical",
        name: "proStatistical",
        component: () => import("@/views/sta/pro/index"),
        meta: {
          perms: ["cms:proStatistical:list"],
          title: "商品统计数据",
          icon: "mms-list"
        }
      },
      {
        path: "tradeStatistical",
        name: "tradeStatistical",
        component: () => import("@/views/sta/trade/index"),
        meta: {
          perms: ["cms:tradeStatistical:list"],
          title: "订单统计数据",
          icon: "mms-list"
        }
      }
    ]
  },
  {
    path: "/cms",
    component: Layout,
    redirect: "/cms/questionList",
    name: "cms",
    meta: {
      title: "内容管理",
      icon: "cms"
    },
    children: [
      {
        path: "questionList",
        name: "questionList",
        component: () => import("@/views/cms/questionList/index"),
        meta: {
          perms: ["cms:questionList:list"],
          title: "常见问题",
          icon: "cms-question"
        }
      },
      {
        path: "addQuestion",
        name: "addQuestion",
        component: () => import("@/views/cms/questionList/addQuestion"),
        meta: {
          perms: ["cms:addQuestion:create"],
          title: "添加问题"
        },
        hidden: true
      },
      {
        path: "editQuestion",
        name: "editQuestion",
        component: () => import("@/views/cms/questionList/editQuestion"),
        meta: {
          perms: ["cms:editQuestion:update"],
          title: "编辑问题"
        },
        hidden: true
      },
      {
        path: "areaManage",
        name: "areaManage",
        component: () => import("@/views/cms/areaManage/index"),
        meta: {
          perms: ["cms:areaManage:list"],
          title: "区域管理",
          icon: "cms-area"
        }
      },
      {
        path: "wordList",
        name: "wordList",
        component: () => import("@/views/cms/wordList/index"),
        meta: {
          perms: ["cms:questionList:list"],
          title: "词库列表",
          icon: "cms-question"
        }
      }
    ]
  },
  {
    path: "/am",
    component: Layout,
    redirect: "/am/administrators",
    name: "am",
    meta: {
      title: "权限安全",
      icon: "am"
    },
    children: [
      {
        path: "department",
        name: "department",
        component: () => import("@/views/am/department/department"),
        meta: {
          perms: ["am:department:list"],
          title: "部门管理",
          icon: "am-bumen"
        }
      },
      {
        path: "departmentJurisdiction",
        name: "departmentJurisdiction",
        component: () => import("@/views/am/department/departmentJurisdiction"),
        meta: {
          perms: ["am:departmentJurisdiction:read"],
          title: "部门权限",
          icon: "sms-flash"
        },
        hidden: true
      },
      {
        path: "operation",
        name: "operation",
        component: () => import("@/views/am/administrators/operation"),
        meta: {
          perms: ["am:operation:list"],
          title: "管理员操作",
          icon: "am-guanli"
        }
      },
      {
        path: "permissionList",
        name: "permissionList",
        component: () => import("@/views/am/permission/index"),
        meta: {
          perms: ["am:permissionList:list"],
          title: "权限列表",
          icon: "am-bumen"
        }
      },
      {
        path: "jurisdictionList",
        name: "jurisdictionList",
        component: () => import("@/views/am/administrators/jurisdictionList"),
        meta: {
          perms: ["am:jurisdictionList:list"],
          title: "操作日志",
          icon: "am-diary"
        }
      }
    ]
  },

  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

export default new Router({
  mode: "history", //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [...constantRouterMap]
});



// WEBPACK FOOTER //
// ./src/router/index.js